// extracted by mini-css-extract-plugin
module.exports = {"item":"search-result-item_item__1aLoZ"};